<div class="upload-page">
  <main class="card">
    <h1>Upload your files</h1>

    <ng-container [ngSwitch]="state">
      <p *ngSwitchCase="'loading'">Checking your link…</p>

      <ng-container *ngSwitchCase="'invalid'">
        <p class="error">This link is not valid.</p>
        <p class="hint">It may have expired or already been used. Please ask the person who sent it for a new one.</p>
      </ng-container>

      <ng-container *ngSwitchCase="'done'">
        <p class="ok">Files received.</p>
        <p class="hint">
          {{ receivedCount }} file(s) received on {{ receivedAt | date: 'medium' }}. Thank you, you can close this page.
        </p>
      </ng-container>

      <ng-container *ngSwitchDefault>
        <p class="hint">
          Send a medical disc, image files or documents. This link works for {{ daysLeft }} more day(s) and accepts up to {{ maxGb }} GB.
          You will not be able to see anything that was sent before.
        </p>

        <div class="actions">
          <button type="button" mat-flat-button color="primary" [disabled]="!canChoose" (click)="chooseFolder()">Select a disc folder</button>
          <button type="button" mat-stroked-button [disabled]="!canChoose" (click)="chooseFiles()">Select files</button>
        </div>
        <input #folderInput type="file" hidden webkitdirectory (change)="onSelected($event, true)" />
        <input #filesInput type="file" hidden multiple (change)="onSelected($event, false)" />

        <p *ngIf="state === 'reading'">Reading your selection…</p>
        <p *ngIf="message" class="error" role="alert">{{ message }}</p>

        <ng-container *ngIf="items.length">
          <p class="summary">
            {{ items.length }} file(s) selected<span *ngIf="state !== 'selected'">, {{ doneCount }} sent<span *ngIf="failedCount">, {{ failedCount }} failed</span></span>.
          </p>

          <div *ngIf="state === 'uploading' || state === 'uploaded' || state === 'finishing'" class="progress" role="progressbar" [attr.aria-valuenow]="overallPercent" aria-valuemin="0" aria-valuemax="100">
            <div class="bar" [style.width.%]="overallPercent"></div>
          </div>

          <ul class="files" *ngIf="items.length <= 200">
            <li *ngFor="let i of items" [ngClass]="i.status">
              <span class="name">{{ i.relativePath }}</span>
              <span class="st">{{ i.status === 'uploading' ? i.progress + '%' : i.status }}</span>
            </li>
          </ul>
          <p class="hint" *ngIf="items.length > 200">Showing progress only: there are too many files to list.</p>

          <div class="actions">
            <button type="button" mat-flat-button color="primary" *ngIf="state === 'selected'" (click)="upload()">Start upload</button>
            <button type="button" mat-stroked-button *ngIf="state === 'uploaded' && failedCount" (click)="retryFailed()">Retry failed files</button>
            <button type="button" mat-flat-button color="primary" *ngIf="state === 'uploaded' || state === 'finishing'" [disabled]="state === 'finishing' || doneCount === 0" (click)="finish()">Finish</button>
          </div>
          <p class="hint" *ngIf="state === 'uploaded'">Press Finish when you have sent everything. After that, this link stops working.</p>
        </ng-container>
      </ng-container>
    </ng-container>
  </main>
</div>
